import * as React from "react";
import { CustomNodeElementProps } from "react-d3-tree";
import * as uuid from "uuid";

const textLayout = { textAnchor: "start", x: 10, y: -10, transform: "scale(0.8)" };

export const renderElement = (type: string, elementProps: any, nodeProps: CustomNodeElementProps) => {
  const { name, attributes } = nodeProps.nodeDatum;
  return (
    <>
      {React.createElement(type, {
        ...elementProps,
        onClick: (evt) => {
          nodeProps.toggleNode();
          nodeProps.onNodeClick(evt);
          evt.stopPropagation();
        },
      })}
      <g
        className="rd3t-label"
        onClick={(evt) => {
          nodeProps.toggleNode();
          nodeProps.onNodeClick(evt);
          evt.stopPropagation();
        }}
      >
        <text
          className="rd3t-label__title"
          textAnchor={textLayout.textAnchor}
          x={textLayout.x}
          y={textLayout.y}
          transform={textLayout.transform}
          dy=".35em"
        >
          {name}
        </text>
        <text
          className="rd3t-label__attributes"
          y={textLayout.y + 10}
          textAnchor={textLayout.textAnchor}
          transform={textLayout.transform}
        >
          {attributes &&
            Object.keys(attributes).map((labelKey) => (
              <tspan x={textLayout.x} dy="1.2em" key={uuid.v4()}>
                {labelKey}: {attributes[labelKey]}
              </tspan>
            ))}
        </text>
      </g>
    </>
  );
};
